export default "__VITE_PUBLIC_ASSET__1de9d8e6__"